export const printHtml = (html: string): void => {
  const iframe = document.createElement('iframe')

  iframe.setAttribute('aria-hidden', 'true')
  iframe.tabIndex = -1
  Object.assign(iframe.style, { border: '0', bottom: '0', height: '0', position: 'fixed', right: '0', width: '0' })

  iframe.addEventListener(
    'load',
    () => {
      const { contentWindow } = iframe

      if (!contentWindow) {
        iframe.remove()
        return
      }

      contentWindow.addEventListener('afterprint', () => iframe.remove(), { once: true })
      contentWindow.focus()
      contentWindow.print()
    },
    { once: true },
  )

  iframe.srcdoc = html
  document.body.appendChild(iframe)
}
